/**
 * When CSS `zoom` is applied (e.g. `html { zoom: 81% }`), getBoundingClientRect()
 * returns coordinates in the zoomed (viewport) space, while Chart.js internally
 * works in un-zoomed CSS-pixel space.  event.offsetX/offsetY are also unreliable
 * under CSS zoom.
 *
 * This plugin recalculates the pointer position by converting viewport coordinates
 * back to the element's own CSS-pixel coordinate space using the ratio
 * rect.width / offsetWidth as the effective zoom factor.
 */
const chartMouseFixPlugin = {
    id: 'chartMouseFix',

    beforeEvent(chart, args) {
        const event = args.event;
        if (!event || !event.native) return;

        const canvas = chart.canvas;
        const rect   = canvas.getBoundingClientRect();
        const native = event.native;

        // Effective CSS zoom = rendered size / CSS layout size
        const zoomX = rect.width  / canvas.offsetWidth;
        const zoomY = rect.height / canvas.offsetHeight;

        // Convert viewport-space pointer position → un-zoomed CSS-pixel space
        event.x = (native.clientX - rect.left) / zoomX;
        event.y = (native.clientY - rect.top)  / zoomY;
    }
};

export default chartMouseFixPlugin;